import { FC, HTMLAttributes } from 'react';
import { merge } from '../../utils/utility';
import { baseCardClass } from '../CommonClasses';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export const Card: FC<CardProps> = ({ children, className }) => {
  return <div className={merge(className, baseCardClass, 'p-5 flex flex-col gap-5')}>{children}</div>;
};
